export const GOLFERS = [
 {
	name: "Scottie Scheffler",
	position: 1,
    toPar: -11,
	posQualifier: "",
	rounds: ['66', '72', '71', '68'],
	winnings: 3600000,
},
{
	name: "Rory McIlroy",
	position: 22,
    toPar: 4,
	posQualifier: "T",
	rounds: ['71', '77', '71', '73'],
	winnings: 175500,
},
{
	name: "Collin Morikawa",
	position: 3,
    toPar: -4,
	posQualifier: "T",
	rounds: ['71', '70', '69', '74'],
	winnings: 1040000,
},
{
	name: "Xander Schauffele",
	position: 8,
    toPar: -1,
	posQualifier: "",
	rounds: ['72', '72', '70', '73'],
	winnings: 620000,
},
{
	name: "Brooks Koepka",
	position: 45,
    toPar: 9,
	posQualifier: "T",
	rounds: ['73', '73', '76', '75'],
	winnings: 57200,
},
{
	name: "Jon Rahm",
	position: 45,
    toPar: 9,
	posQualifier: "T",
	rounds: ['73', '76', '72', '76'],
	winnings: 57200,
},
{
	name: "Wyndham Clark",
	position: 61,
    toPar: 7,
	posQualifier: "MC",
	rounds: ['73', '78', '-', '-'],
	winnings: 10000,
},
{
	name: "Ludvig Aberg",
	position: 2,
    toPar: -7,
	posQualifier: "",
	rounds: ['73', '69', '70', '69'],
	winnings: 2160000,
},
{
	name: "Joaquin Niemann",
	position: 22,
    toPar: 4,
	posQualifier: "T",
	rounds: ['70', '78', '71', '73'],
	winnings: 175500,
},
{
	name: "Hideki Matsuyama",
	position: 38,
    toPar: 7,
	posQualifier: "T",
	rounds: ['76', '74', '71', '74'],
	winnings: 86000,
},
{
	name: "Tom Kim",
	position: 30,
    toPar: 5,
	posQualifier: "T",
	rounds: ['72', '78', '77', '66'],
	winnings: 124200,
},
{
	name: "Sahith Theegala",
	position: 45,
    toPar: 9,
	posQualifier: "T",
	rounds: ['74', '74', '74', '75'],
	winnings: 57200,
},
{
	name: "Viktor Hovland",
	position: 61,
    toPar: 8,
	posQualifier: "MC",
	rounds: ['71', '81', '-', '-'],
	winnings: 10000,
},
{
	name: "Dustin Johnson",
	position: 61,
    toPar: 13,
	posQualifier: "MC",
	rounds: ['78', '79', '-', '-'],
	winnings: 10000,
},
{
	name: "Tommy Fleetwood",
	position: 3,
    toPar: -4,
	posQualifier: "T",
	rounds: ['72', '71', '72', '69'],
	winnings: 1040000,
},
{
	name: "Matt Fitzpatrick",
	position: 22,
    toPar: 4,
	posQualifier: "T",
	rounds: ['71', '73', '73', '75'],
	winnings: 175500,
},
{
	name: "Will Zalatoris",
	position: 9,
    toPar: 0,
	posQualifier: "T",
	rounds: ['70', '77', '72', '69'],
	winnings: 540000,
},
{
	name: "Patrick Cantlay",
	position: 22,
    toPar: 4,
	posQualifier: "T",
	rounds: ['71', '75', '70', '76'],
	winnings: 175500,
},
{
	name: "Jordan Spieth",
	position: 61,
    toPar: 7,
	posQualifier: "MC",
	rounds: ['79', '74', '-', '-'],
	winnings: 10000,
},
{
	name: "Bryson DeChambeau",
	position: 6,
    toPar: -2,
	posQualifier: "T",
	rounds: ['65', '73', '75', '73'],
	winnings: 695000,
},
{
	name: "Cameron Young",
	position: 9,
    toPar: 0,
	posQualifier: "T",
	rounds: ['70', '73', '72', '73'],
	winnings: 540000,
},
{
	name: "Shane Lowry",
	position: 43,
    toPar: 8,
	posQualifier: "T",
	rounds: ['73', '74', '75', '74'],
	winnings: 72000,
},
{
	name: "John Rahm",
	position: 45,
    toPar: 9,
	posQualifier: "T",
	rounds: ['73', '76', '72', '76'],
	winnings: 57200,
},
{
	name: "Russell Henley",
	position: 38,
    toPar: 7,
	posQualifier: "T",
	rounds: ['73', '77', '74', '71'],
	winnings: 86000,
},
{
	name: "Corey Conners",
	position: 38,
    toPar: 7,
	posQualifier: "T",
	rounds: ['70', '76', '76', '73'],
	winnings: 86000,
},
{
	name: "Sungjae Im",
	position: 61,
    toPar: 7,
	posQualifier: "MC",
	rounds: ['77', '74', '-', '-'],
	winnings: 10000,
},
{
	name: "Tiger Woods",
	position: 60,
    toPar: 16,
	posQualifier: "T",
	rounds: ['73', '72', '82', '77'],
	winnings: 39600,
},
{
	name: "Max Homa",
	position: 3,
    toPar: -4,
	posQualifier: "T",
	rounds: ['67', '71', '73', '73'],
	winnings: 1040000,
},
]

